import Cookies from 'js-cookie'
import Highcharts from "highcharts"

//节流 搜索框中使用
export function debounce(func, delay) {
	let timer
	return function (...args) {
		if (timer) {
			clearTimeout(timer)
		}
		timer = setTimeout(() => {
			func.apply(this, args)
		}, delay)
	}
}

//根据当前语言环境修改日期国际化
export function getLocal() {
	let language = Cookies.get('language')
	if(language === 'zh'){
		// 中文
		return {
			dow: 1, // Monday is the first day of the week
			hourTip: '选择小时', // tip of select hour
			minuteTip: '选择分钟', // tip of select minute
			secondTip: '选择秒数', // tip of select second
			yearSuffix: '年', // format of head
			monthsHead: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'), // months of head
			months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'), // months of panel
			weeks: '一_二_三_四_五_六_日'.split('_'), // weeks
			cancelTip: '取消', // default text for cancel button
			submitTip: '确定' // default text for submit button
		}
	}else {
		return {
			dow: 0, // Sunday is the first day of the week
			hourTip: 'Select Hour', // tip of select hour
			minuteTip: 'Select Minute', // tip of select minute
			secondTip: 'Select Second', // tip of select second
			yearSuffix: '', // suffix of head year
			monthsHead: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'), // months of head
			months: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'), // months of panel
			weeks: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'), // weeks,
			cancelTip: 'cancel',
			submitTip: 'confirm',
		}
	}
}


// 时间类转为 formatTime(new Date(), 'Y-M-D h:m:s')
export function formatTime(dt,f){
	var week=["星期日","星期一","星期二","星期三","星期四","星期五","星期六"];
	if(dt){
		var Y = dt.getFullYear();
		var M = toZero(dt.getMonth()+1);
		var D = toZero(dt.getDate());
		var h = toZero(dt.getHours());
		var m = toZero(dt.getMinutes());
		var s = toZero(dt.getSeconds());

		var week = week[dt.getDay()];

		f = f.replace(/Y/g,Y);
		f = f.replace(/M/g,M);
		f = f.replace(/D/g,D);
		f = f.replace(/h/g,h);
		f = f.replace(/m/g,m);
		f = f.replace(/s/g,s);
		f = f.replace(/week/g,week);

		return f;
	}
}

function toZero(n) {
	return  n<=9 ? '0'+n : ''+n
}

// formatTime(new Date(),'Y/M')

export function time(s, format, type = "system",offset=0) {//offset unit : ms
	s*=1000;
	s=Math.round(s);
	if(s!=undefined){
		switch(type){
			case "system":s+=stage.time.localOffset;break;
			case "utc":break;
			case "inc":s+=stage.time.offset;break;
			case "offset":s+=offset;break;

			// case "":break;
			// default:break;
		}
	}
	return s?Highcharts.dateFormat(format,s):"";//%Y/%m/%d or %Y/%m/%d and %H:%M:%S
}


// 深度拷贝
export function deepClone(parent,c) {
	let child = c || {}
	for(var key  in parent) {
		if(parent.hasOwnProperty(key)) {
			let val = parent[key]
			if(val != null && typeof val === 'object') {
				child[key] = Object.prototype.toString.call(val) === '[object Array]' ? [] : {}
				deepClone(parent[key],child[key])
			}else {
				child[key] = parent[key]
			}
		}
	}
	return child
}





// WEBPACK FOOTER //
// ./src/util/index.js